import Link from 'next/link';
import { useRouter } from 'next/router';

import { PrimaryButton, SecondaryButton } from '../components/Buttons/Buttons';
import CustomHead from '../components/CustomHead';
import MainLogo from '../components/MainLogo/MainLogo';

import styles from './digital-cards.module.scss';

export default function DigitalCards() {
  const router = useRouter();

  function onClickLogin() {
    router.push({
      pathname: '/login',
      query: { isDigital: 'digital' },
    });
  }

  function onClicRegister() {
    router.push({
      pathname: '/register-digital-card',
    });
  }

  return (
    <section className={styles.container}>
      <CustomHead title="Σύνδεση Digital Card/ Εγγραφή Digital Card" />
      <div className={styles.logoContainer}>
        <Link href="/">
          <a>
            <MainLogo />
          </a>
        </Link>
      </div>
      <h1 className={styles.header}>Απόκτησε τη δική σου ψηφιακή κάρτα</h1>

      <div className={styles.imageContainer}>
        <img
          className={styles.img}
          width="200"
          height="200"
          src={`/assets/${process.env.appName}/${process.env.appName}-login.png`}
          alt="grocery app"
        />
      </div>
      <p className={styles.p}>
        Εάν έχεις κάρτα ΚΡΗΤΙΚΟΣ τότε είσαι ήδη μέλος του προγράμματος επιβράβευσης. Κάνε σύνδεση και μετέτρεψε την
        κάρτα σου σε ψηφιακή για να την έχεις πάντα μαζί στο κινητό σου!
      </p>
      <p className={styles.secondParagraph}>
        Εναλλακτικά μπορείς να κάνεις εγγραφή άμεσα και γρήγορα ώστε να επωφεληθείς από το πρόγραμμα.
      </p>

      <div className={styles.primaryButtonContainer}>
        <PrimaryButton type="submit" data-cy="log-in-digital" style={{ width: '100%' }} onClick={() => onClickLogin()}>
          Συνέχεια
        </PrimaryButton>
      </div>
      <div className={styles.secondaryButtonContainer}>
        <SecondaryButton
          onClick={() => onClicRegister()}
          data-cy="register-digital"
          style={{ width: '100%', marginBottom: '1rem' }}
        >
          Εγγραφή
        </SecondaryButton>
      </div>
    </section>
  );
}
